export const LOCATION_DIALING_CODE_START = 'location/dialing/REQUEST_START';
export const LOCATION_DIALING_CODE_FAIL = 'location/dialing/REQUEST_FAIL';
export const LOCATION_DIALING_CODE_SUCCESS = 'location/dialing/REQUEST_SUCCESS';

export interface LocationDialingCodeTypes {
    countryName: string;
    countryCode2d: string;
    countryCode3d: string;
    stateName: string;
    stateCode: string;
}

export interface DialingCodeState {
    loadingState: string;
    locationDialingCodeData: LocationDialingCodeTypes | null;
}